// extracted by mini-css-extract-plugin
export var container = "_87-0";
export var error = "_87-9";
export var label = "_87-5";
export var light = "_87-6";
export var md = "_87-3";
export var sm = "_87-2";
export var thin = "_87-8";
export var thinBold = "_87-7";
export var vertical = "_87-4";
export var xs = "_87-1";